/// <reference types="bingmaps" />
import { usePreviousProp } from '@infl-ts/util-hooks';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { Head } from '../head';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var removeEntities = function removeEntities(map, filter) {
  for (var i = map.entities.getLength() - 1; i >= 0; i--) {
    var polygon = map.entities.get(i);
    if (filter(polygon)) map.entities.removeAt(i);
  }
};

var addPolygons = function addPolygons(map, polygons) {
  polygons.forEach(function (polygon) {
    var location = new Microsoft.Maps.Location(polygon.center.latitude, polygon.center.longitude);
    Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', function () {
      var locations = Microsoft.Maps.SpatialMath.getRegularPolygon(location, polygon.radius, polygon.points, Microsoft.Maps.SpatialMath.DistanceUnits.Meters);
      map.entities.push(new Microsoft.Maps.Polygon(locations, polygon.options));
    });
  });
};

var addPushPins = function addPushPins(map, pushPins) {
  pushPins.forEach(function (pushPin) {
    var location = new Microsoft.Maps.Location(pushPin.location.latitude, pushPin.location.longitude);
    map.entities.push(new Microsoft.Maps.Pushpin(location, pushPin.options));
  });
};

var nonEmptyCoords = function nonEmptyCoords(coords) {
  return coords.latitude !== 0 && coords.longitude !== 0;
}; // WARNING: only supports one instance per page


export var Bingmap = function Bingmap(_ref) {
  var apiKey = _ref.apiKey,
      onInitialize = _ref.onInitialize,
      center = _ref.center,
      pushPins = _ref.pushPins,
      zoom = _ref.zoom,
      polygons = _ref.polygons,
      sx = _ref.sx;

  var _useState = useState(null),
      map = _useState[0],
      setMap = _useState[1];

  var previousCenter = usePreviousProp(center);
  useEffect(function () {
    var _window, _window$Microsoft, _window$Microsoft$Map;

    window.bingmapsCallback = function () {
      var mapInstance = new Microsoft.Maps.Map('#bingmap', {
        credentials: apiKey
      });
      setMap(mapInstance);
      onInitialize && onInitialize(mapInstance);
    };

    if ((_window = window) !== null && _window !== void 0 && (_window$Microsoft = _window.Microsoft) !== null && _window$Microsoft !== void 0 && (_window$Microsoft$Map = _window$Microsoft.Maps) !== null && _window$Microsoft$Map !== void 0 && _window$Microsoft$Map.Map) window.bingmapsCallback();
  }, []);
  useEffect(function () {
    if (center && nonEmptyCoords(center) && previousCenter && nonEmptyCoords(previousCenter) && center.latitude != previousCenter.latitude && center.longitude != previousCenter.longitude && map) map.setView({
      center: new Microsoft.Maps.Location(center.latitude, center.longitude)
    });
  }, [center, map]);
  useEffect(function () {
    zoom && map && map.setView({
      zoom: zoom
    });
  }, [zoom, map]);
  useEffect(function () {
    if (!map) return;
    removeEntities(map, function (polygon) {
      return polygon instanceof Microsoft.Maps.Polygon;
    });
    polygons && addPolygons(map, polygons);
  }, [polygons, map]);
  useEffect(function () {
    if (!map) return;
    removeEntities(map, function (pushpin) {
      return pushpin instanceof Microsoft.Maps.Pushpin;
    });
    pushPins && addPushPins(map, pushPins);
  }, [pushPins, map]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      "data-element": "Head",
      "data-component": "Bingmap",
      "data-source-file": "index.tsx",
      children: /*#__PURE__*/_jsx("script", {
        type: "text/javascript",
        src: "https://www.bing.com/api/maps/mapcontrol?callback=bingmapsCallback",
        async: true,
        defer: true,
        "data-component": "Bingmap",
        "data-source-file": "index.tsx"
      })
    }), /*#__PURE__*/_jsx(Box, {
      id: "bingmap",
      sx: sx,
      "data-element": "Box",
      "data-source-file": "index.tsx"
    })]
  });
};